module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-expand-0679b4fb.svg";